import React, { useContext } from 'react';

import Checkbox from '../../Checkbox/Checkbox';
import Radio from '../../Radio/Radio';
import TableCell from '../TableCell/TableCell';

import TableContext from '../TableContext/TableContext';

export interface SelectableCellProps {
  index?: number;
  rowIndex: number;
  twiddle?: boolean;
  total?: boolean;
  selected?: boolean;
  twiddleContent?: boolean;
  freeze?: boolean;
}

function SelectableCell(props: SelectableCellProps) {
  const { tableId, selectable, selected, selectRow } = useContext(TableContext);
  const { index, total, rowIndex, twiddleContent } = props;

  const isSelected = (index: number): boolean => {
    if (selectable) {
      return selected.includes(index);
    }
    return false;
  };

  if (!selectable) {
    return null;
  }

  if (twiddleContent || total) {
    return <TableCell shaded={twiddleContent} freeze={props.freeze} />;
  }

  return (
    <>
      {selectable === 'all' && !total && (
        <TableCell {...props} checkbox>
          <Checkbox
            isCell
            id={`${tableId}-${rowIndex}-${index}`}
            value={isSelected(rowIndex)}
            onChange={() => selectRow(rowIndex)}
          />
        </TableCell>
      )}
      {selectable === 'single' && !total && (
        <TableCell {...props} checkbox>
          <Radio
            id={`${tableId}-${rowIndex}`}
            options={[
              {
                id: `${tableId}-${rowIndex}-${index}`,
                value: `${tableId}-${rowIndex}-${index}`,
                label: '',
                isChecked: rowIndex === selected[0],
              },
            ]}
            isTable
            isCell
            onChange={() => selectRow(rowIndex)}
          />
        </TableCell>
      )}
    </>
  );
}

SelectableCell.defaultProps = {
  index: 0,
  rowIndex: null,
  total: false,
  twiddleContent: false,
  freeze: false,
};

export default SelectableCell;
